import Checkbox from 'components/ui/Checkbox/Checkbox';
import { CSSProperties, useId } from 'react';
import { useTranslation } from 'react-i18next';
import Switch from 'react-switch';
import {
  displayModeOldOptions,
  displayModePrimaryOptions,
  getDisplayModeValue,
  resolveDisplayModeSelection,
} from 'constants/constant';
import { colorContrast } from 'constants/generic';

type DisplayModeConfigProps = {
  value: number;
  onChange: (value: number) => void;
  showTitle?: boolean;
  className?: string;
  style?: CSSProperties;
};

const lastOldOption = displayModeOldOptions[displayModeOldOptions.length - 1];

const DisplayModeConfig = ({
  value,
  onChange,
  showTitle = true,
  className,
  style,
}: DisplayModeConfigProps) => {
  const { t } = useTranslation();
  const switchId = useId();
  const { baseValue, isMultiPrice, isOldDisplay } = resolveDisplayModeSelection(value);
  const isMultiPriceDisabled = isOldDisplay && baseValue === lastOldOption.value;

  const onSelectPrimary = (nextBaseValue: number) => {
    const nextValue = getDisplayModeValue(
      nextBaseValue,
      isMultiPrice && !isMultiPriceDisabled,
      false
    );
    if (nextValue === value) {
      return;
    }
    onChange(nextValue);
  };

  const onSelectOld = (nextBaseValue: number) => {
    const isLastOption = nextBaseValue === lastOldOption.value;
    const nextValue = getDisplayModeValue(
      nextBaseValue,
      isLastOption ? false : isMultiPrice,
      true
    );
    if (nextValue === value) {
      return;
    }
    onChange(nextValue);
  };

  const onToggleMultiPrice = (checked: boolean) => {
    if (isMultiPriceDisabled) {
      return;
    }

    const nextValue = getDisplayModeValue(baseValue, checked, isOldDisplay);
    if (nextValue === value) {
      return;
    }
    onChange(nextValue);
  };

  return (
    <div className={'display-mode-config' + (className ? ` ${className}` : '')} style={style}>
      {showTitle && <div className="mb-5">{t('hotel.display_mode')}</div>}
      <div className="mb-15">
        {displayModePrimaryOptions.map((mode) => (
          <Checkbox
            key={mode.value}
            className="mb-5"
            onlyChecked
            checked={!isOldDisplay && baseValue === mode.value}
            onChange={() => onSelectPrimary(mode.value)}
            label={t(mode.label)}
          />
        ))}
        {displayModeOldOptions.map((mode) => (
          <Checkbox
            key={mode.value}
            className="mb-5"
            onlyChecked
            checked={isOldDisplay && baseValue === mode.value}
            onChange={() => onSelectOld(mode.value)}
            label={t(mode.label)}
          />
        ))}
      </div>
      <div className="flex-v-center">
        <Switch
          checked={isMultiPrice && !isMultiPriceDisabled}
          onChange={onToggleMultiPrice}
          disabled={isMultiPriceDisabled}
          uncheckedIcon={false}
          checkedIcon={false}
          onColor={colorContrast}
          height={16}
          width={32}
          handleDiameter={14}
          id={switchId}
        />
        <label htmlFor={switchId} className="ml-5 cur-poi">
          Multi Price
        </label>
      </div>
    </div>
  );
};

export default DisplayModeConfig;
